module.exports = __webpack_public_path__ + "img/张家口.27a77528.png";